// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";


export interface IId {
    id?: number;
    /**
     * load specific relation
     */
    relations?: string[];
    select?: string[];

}
export class Id implements IId {

    id?: number;
    relations?: string[];
    select?: string[];

    constructor(data?: Partial<IId>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MId extends Message implements Id {

    constructor(data?: Partial<IId>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2,3], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("relations" in data && data.relations != undefined) this.relations = data.relations;
            if ("select" in data && data.select != undefined) this.select = data.select;
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get relations(): string[] {
        return Message.getField(this, 2) as string[];
    }
    set relations(value: string[]) {
        Message.setField(this, 2, value);
    }

    get select(): string[] {
        return Message.getField(this, 3) as string[];
    }
    set select(value: string[]) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Id() : {} as Id;
        if (this.id != undefined) data.id = this.id;
        if (this.relations?.length) data.relations = this.relations;
        if (this.select?.length) data.select = this.select;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.relations !== undefined) writer.writeRepeatedString(2, this.relations);
                if (this.select !== undefined) writer.writeRepeatedString(3, this.select);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IId): Uint8Array {
        return (data instanceof Message ? (data as MId) : new MId(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MId {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MId();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    Message.addToRepeatedField(message, 2, reader.readString());
                    break;
            case 3:
                    Message.addToRepeatedField(message, 3, reader.readString());
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MId {
        return MId.deserializeBinaryFromReader(new MId(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MId, reader: BinaryReader) {
        return Object.assign(msg, MId.deserialize(reader))
    };

}
export interface IIds {
    ids?: number[];
    /**
     * load specific relation
     */
    relations?: string[];
    select?: string[];

}
export class Ids implements IIds {

    ids?: number[];
    relations?: string[];
    select?: string[];

    constructor(data?: Partial<IIds>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MIds extends Message implements Ids {

    constructor(data?: Partial<IIds>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1,2,3], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("ids" in data && data.ids != undefined) this.ids = data.ids;
            if ("relations" in data && data.relations != undefined) this.relations = data.relations;
            if ("select" in data && data.select != undefined) this.select = data.select;
        }
    }

    get ids(): number[] {
        return Message.getField(this, 1) as number[];
    }
    set ids(value: number[]) {
        Message.setField(this, 1, value);
    }

    get relations(): string[] {
        return Message.getField(this, 2) as string[];
    }
    set relations(value: string[]) {
        Message.setField(this, 2, value);
    }

    get select(): string[] {
        return Message.getField(this, 3) as string[];
    }
    set select(value: string[]) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Ids() : {} as Ids;
        if (this.ids?.length) data.ids = this.ids;
        if (this.relations?.length) data.relations = this.relations;
        if (this.select?.length) data.select = this.select;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.ids !== undefined) writer.writeRepeatedInt32(1, this.ids);
                if (this.relations !== undefined) writer.writeRepeatedString(2, this.relations);
                if (this.select !== undefined) writer.writeRepeatedString(3, this.select);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IIds): Uint8Array {
        return (data instanceof Message ? (data as MIds) : new MIds(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MIds {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MIds();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    Message.addToRepeatedField(message, 1, reader.readInt32());
                    break;
            case 2:
                    Message.addToRepeatedField(message, 2, reader.readString());
                    break;
            case 3:
                    Message.addToRepeatedField(message, 3, reader.readString());
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MIds {
        return MIds.deserializeBinaryFromReader(new MIds(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MIds, reader: BinaryReader) {
        return Object.assign(msg, MIds.deserialize(reader))
    };

}
export enum CriteriaOperator {
    UNDEFINED_CriteriaOperator = 0,
    EQUAL = 1,
    LESS = 2,
    GREATER = 3,
    GREATER_OR_EQUAL = 4,
    LESS_OR_EQUAL = 5,
    IS_TRUE = 6,
    IS_FALSE = 21,
    IS_NULL = 7,
    LIKE = 9,
    /**
     * like case-insensitive
     */
    I_LIKE = 10,
    /**
     * criteria with 2 values: from -> to
     */
    BETWEEN = 11,
    /**
     * criteria with values (OR)
     */
    IN = 12,
    /**
     * criteria with values (AND). On manyToMany or oneToMany relation. no values => have nothing
     */
    HAVING = 14,
    HAVING_COUNT = 15,
    /**
     * criteria with values
     */
    ANY = 13,
    /**
     * criteria with values
     * Ex: ARRAY[1.1,2.1,3.1]::int[] = ARRAY[1,2,3]
     */
    ARRAY_EQUAL = 16,
    /**
     * criteria with values
     * EX: ARRAY[1,2,3] <> ARRAY[1,2,4]
     */
    ARRAY_NOT_EQUAL = 17,
    /**
     * criteria with values
     * Ex: ARRAY[1,4,3] @> ARRAY[3,1]
     */
    ARRAY_CONTAINS = 18,
    /**
     * criteria with values
     * Ex: ARRAY[2,7] <@ ARRAY[1,7,4,2,6]
     */
    ARRAY_IS_CONTAINS_BY = 19,
    /**
     * overlap (have elements in common) ARRAY[1,4,3] && ARRAY[2,1]
     */
    ARRAY_OVERLAP = 20,
}
/**
 * An example to understand 'or' and 'group' fields, 2 solutions => same result:
 * [A or, B or, C]
 * [A group1, C group1, B group2, C group2]
 * => (A AND C) OR (B AND C)
 */
export interface ICriteria {
    /**
     * field path. Add '.' for child fields
     */
    field?: string;
    /**
     * use value or values depend of operator (default operator EQUAL)
     */
    value?: string;
    /**
     * use value or values depend of operator (default operator IN)
     */
    values?: string[];
    /**
     * (optional) default IN if values, EQUAL if value
     */
    operator?: CriteriaOperator;
    /**
     * (optional) default false.
     */
    not?: boolean;
    /**
     * (optional) default AND. AND or OR between criteria (in the same group)
     */
    or?: boolean;
    /**
     * (optional) group criteria whith OR separator. Ex: (crit_group_1, crit_group_1, ...) OR (crit_group_2)
     */
    group?: number;

}
export class Criteria implements ICriteria {

    field?: string;
    value?: string;
    values?: string[];
    operator?: CriteriaOperator;
    not?: boolean;
    or?: boolean;
    group?: number;

    constructor(data?: Partial<ICriteria>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
/**
 * An example to understand 'or' and 'group' fields, 2 solutions => same result:
 * [A or, B or, C]
 * [A group1, C group1, B group2, C group2]
 * => (A AND C) OR (B AND C)
 */
export class MCriteria extends Message implements Criteria {

    constructor(data?: Partial<ICriteria>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("field" in data && data.field != undefined) this.field = data.field;
            if ("value" in data && data.value != undefined) this.value = data.value;
            if ("values" in data && data.values != undefined) this.values = data.values;
            if ("operator" in data && data.operator != undefined) this.operator = data.operator;
            if ("not" in data && data.not != undefined) this.not = data.not;
            if ("or" in data && data.or != undefined) this.or = data.or;
            if ("group" in data && data.group != undefined) this.group = data.group;
        }
    }

    get field(): string {
        return Message.getField(this, 1) as string;
    }
    set field(value: string) {
        Message.setField(this, 1, value);
    }

    get value(): string {
        return Message.getField(this, 2) as string;
    }
    set value(value: string) {
        Message.setField(this, 2, value);
    }

    get values(): string[] {
        return Message.getField(this, 3) as string[];
    }
    set values(value: string[]) {
        Message.setField(this, 3, value);
    }

    get operator(): CriteriaOperator {
        return Message.getField(this, 4) as CriteriaOperator;
    }
    set operator(value: CriteriaOperator) {
        Message.setField(this, 4, value);
    }

    get not(): boolean {
        return Message.getField(this, 5) as boolean;
    }
    set not(value: boolean) {
        Message.setField(this, 5, value);
    }

    get or(): boolean {
        return Message.getField(this, 6) as boolean;
    }
    set or(value: boolean) {
        Message.setField(this, 6, value);
    }

    get group(): number {
        return Message.getField(this, 7) as number;
    }
    set group(value: number) {
        Message.setField(this, 7, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Criteria() : {} as Criteria;
        if (this.field != undefined) data.field = this.field;
        if (this.value != undefined) data.value = this.value;
        if (this.values?.length) data.values = this.values;
        if (this.operator != undefined) data.operator = this.operator;
        if (this.not != undefined) data.not = this.not;
        if (this.or != undefined) data.or = this.or;
        if (this.group != undefined) data.group = this.group;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.field !== undefined) writer.writeString(1, this.field);
                if (this.value !== undefined) writer.writeString(2, this.value);
                if (this.values !== undefined) writer.writeRepeatedString(3, this.values);
                if (this.operator !== undefined) writer.writeEnum(4, this.operator);
                if (this.not !== undefined) writer.writeBool(5, this.not);
                if (this.or !== undefined) writer.writeBool(6, this.or);
                if (this.group !== undefined) writer.writeInt32(7, this.group);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ICriteria): Uint8Array {
        return (data instanceof Message ? (data as MCriteria) : new MCriteria(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MCriteria {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MCriteria();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.field = reader.readString();
                    break;
            case 2:
                    message.value = reader.readString();
                    break;
            case 3:
                    Message.addToRepeatedField(message, 3, reader.readString());
                    break;
            case 4:
                    message.operator = reader.readEnum();
                    break;
            case 5:
                    message.not = reader.readBool();
                    break;
            case 6:
                    message.or = reader.readBool();
                    break;
            case 7:
                    message.group = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MCriteria {
        return MCriteria.deserializeBinaryFromReader(new MCriteria(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MCriteria, reader: BinaryReader) {
        return Object.assign(msg, MCriteria.deserialize(reader))
    };

}
export enum OrderDirection {
    UNDEFINED_OrderDirection = 0,
    ASC = 1,
    DESC = 2,
}
export interface IOrder {
    field?: string;
    direction?: OrderDirection;
    /**
     * null first: ASC / null last: DESC
     */
    nulls?: OrderDirection;

}
export class Order implements IOrder {

    field?: string;
    direction?: OrderDirection;
    nulls?: OrderDirection;

    constructor(data?: Partial<IOrder>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MOrder extends Message implements Order {

    constructor(data?: Partial<IOrder>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("field" in data && data.field != undefined) this.field = data.field;
            if ("direction" in data && data.direction != undefined) this.direction = data.direction;
            if ("nulls" in data && data.nulls != undefined) this.nulls = data.nulls;
        }
    }

    get field(): string {
        return Message.getField(this, 1) as string;
    }
    set field(value: string) {
        Message.setField(this, 1, value);
    }

    get direction(): OrderDirection {
        return Message.getField(this, 2) as OrderDirection;
    }
    set direction(value: OrderDirection) {
        Message.setField(this, 2, value);
    }

    get nulls(): OrderDirection {
        return Message.getField(this, 3) as OrderDirection;
    }
    set nulls(value: OrderDirection) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Order() : {} as Order;
        if (this.field != undefined) data.field = this.field;
        if (this.direction != undefined) data.direction = this.direction;
        if (this.nulls != undefined) data.nulls = this.nulls;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.field !== undefined) writer.writeString(1, this.field);
                if (this.direction !== undefined) writer.writeEnum(2, this.direction);
                if (this.nulls !== undefined) writer.writeEnum(3, this.nulls);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IOrder): Uint8Array {
        return (data instanceof Message ? (data as MOrder) : new MOrder(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MOrder {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MOrder();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.field = reader.readString();
                    break;
            case 2:
                    message.direction = reader.readEnum();
                    break;
            case 3:
                    message.nulls = reader.readEnum();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MOrder {
        return MOrder.deserializeBinaryFromReader(new MOrder(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MOrder, reader: BinaryReader) {
        return Object.assign(msg, MOrder.deserialize(reader))
    };

}
export interface ICriterias {
    criterias?: ICriteria[];
    orders?: IOrder[];
    limit?: number;
    offset?: number;
    /**
     * load specific relation/child object
     * -  'none'  => dont load any data => just count
     * - prefix @ => just load Id relation. Ex: '@labels' => { labels : [{id: 2}, {id: 4}] }
     * load virtual field (not store in bdd but calculate)
     */
    relations?: string[];
    select?: string[];
    withDeleted?: boolean;

}
export class Criterias implements ICriterias {

    criterias?: Criteria[];
    orders?: Order[];
    limit?: number;
    offset?: number;
    relations?: string[];
    select?: string[];
    withDeleted?: boolean;

    constructor(data?: Partial<ICriterias>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MCriterias extends Message implements Criterias {

    constructor(data?: Partial<ICriterias>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1,2,5,6], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("criterias" in data && data.criterias != undefined) this.criterias = data.criterias.map(d => new MCriteria(d));
            if ("orders" in data && data.orders != undefined) this.orders = data.orders.map(d => new MOrder(d));
            if ("limit" in data && data.limit != undefined) this.limit = data.limit;
            if ("offset" in data && data.offset != undefined) this.offset = data.offset;
            if ("relations" in data && data.relations != undefined) this.relations = data.relations;
            if ("select" in data && data.select != undefined) this.select = data.select;
            if ("withDeleted" in data && data.withDeleted != undefined) this.withDeleted = data.withDeleted;
        }
    }

    get criterias(): MCriteria[] {
        return Message.getRepeatedWrapperField(this, MCriteria, 1);
    }
    set criterias(value: MCriteria[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get orders(): MOrder[] {
        return Message.getRepeatedWrapperField(this, MOrder, 2);
    }
    set orders(value: MOrder[]) {
        Message.setRepeatedWrapperField(this, 2, value);
    }

    get limit(): number {
        return Message.getField(this, 3) as number;
    }
    set limit(value: number) {
        Message.setField(this, 3, value);
    }

    get offset(): number {
        return Message.getField(this, 4) as number;
    }
    set offset(value: number) {
        Message.setField(this, 4, value);
    }

    get relations(): string[] {
        return Message.getField(this, 5) as string[];
    }
    set relations(value: string[]) {
        Message.setField(this, 5, value);
    }

    get select(): string[] {
        return Message.getField(this, 6) as string[];
    }
    set select(value: string[]) {
        Message.setField(this, 6, value);
    }

    get withDeleted(): boolean {
        return Message.getField(this, 7) as boolean;
    }
    set withDeleted(value: boolean) {
        Message.setField(this, 7, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Criterias() : {} as Criterias;
        if (this.criterias.length) data.criterias = this.criterias.map(d => d.toObject(includeInstance));

        if (this.orders.length) data.orders = this.orders.map(d => d.toObject(includeInstance));

        if (this.limit != undefined) data.limit = this.limit;
        if (this.offset != undefined) data.offset = this.offset;
        if (this.relations?.length) data.relations = this.relations;
        if (this.select?.length) data.select = this.select;
        if (this.withDeleted != undefined) data.withDeleted = this.withDeleted;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.criterias !== undefined) writer.writeRepeatedMessage(1, this.criterias, (i) => i.serialize(writer));
                if (this.orders !== undefined) writer.writeRepeatedMessage(2, this.orders, (i) => i.serialize(writer));
                if (this.limit !== undefined) writer.writeInt32(3, this.limit);
                if (this.offset !== undefined) writer.writeInt32(4, this.offset);
                if (this.relations !== undefined) writer.writeRepeatedString(5, this.relations);
                if (this.select !== undefined) writer.writeRepeatedString(6, this.select);
                if (this.withDeleted !== undefined) writer.writeBool(7, this.withDeleted);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ICriterias): Uint8Array {
        return (data instanceof Message ? (data as MCriterias) : new MCriterias(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MCriterias {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MCriterias();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.criterias, () => Message.addToRepeatedWrapperField(message, 1, MCriteria.deserialize(reader), MCriteria));
                    break;
            case 2:
                    reader.readMessage(message.orders, () => Message.addToRepeatedWrapperField(message, 2, MOrder.deserialize(reader), MOrder));
                    break;
            case 3:
                    message.limit = reader.readInt32();
                    break;
            case 4:
                    message.offset = reader.readInt32();
                    break;
            case 5:
                    Message.addToRepeatedField(message, 5, reader.readString());
                    break;
            case 6:
                    Message.addToRepeatedField(message, 6, reader.readString());
                    break;
            case 7:
                    message.withDeleted = reader.readBool();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MCriterias {
        return MCriterias.deserializeBinaryFromReader(new MCriterias(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MCriterias, reader: BinaryReader) {
        return Object.assign(msg, MCriterias.deserialize(reader))
    };

}
                                    




export default () => {}